import axios from "@/plugins/axios";

let url = (data) => "/api/v1/company/recruitments/${_recruitment}/applications/${_application}/micepec-records".interpolate(data);

export default {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};
